import { defineStore } from "pinia";
import { CaptionModel, CaptionState } from "../utils/captionModel";
import { AvailableCaption } from "../utils/availableCaptionModel";
import { Language, languages } from "../utils/languageList";
import Player from "video.js/dist/types/player";
interface YoutubeState {
  premiumService: boolean;
  isLoading: boolean;
  hasCaption: boolean;
  hasVideo: boolean;
  isNotValidLink: boolean;
  notReadyYet: boolean;
  isTargetListOpen: boolean;
  isFromNotification: boolean;
  isTargetLanguageSelected: boolean;
  balanceNotEnough: boolean;
  computePricing: boolean;
  captions: CaptionModel[];
  availableCaptions: AvailableCaption[];
  activeCaptionLang: string | "";
  userInput: string | "";
  originalVideoSubtitle: string | "";
  translatedVideoSubtitle: string | "";
  translatedText: string | "";
  translatedSummarizedText: string | "";
  prebuildVideoSubtitle: string | ``;
  originalText: string | ``;
  originalSummarizedText: string | ``;
  searchQuery: string | "";
  myLanguagesList: Language[];
  isTranslationListOpened: boolean;
  translationLanguage: Language;
  originalLanguage: Language;
  isOpen: boolean;
  player: any | null;
  currentTime: number;
  currentCaptions: CaptionModel[];
  currentRequestId: string | "";
  mountPlayer: boolean;
  videoPlayer : Player | null;
  textTranslationPrice: number;
  webvttTextArea1: HTMLTextAreaElement | null;
  webvttTextArea2: HTMLTextAreaElement | null;
  defaultOriginalVideoSubtitle: string | ``;
  defaultTranslatedVideoSubtitle: string | ``;
  defaultOriginalText: string | ``;
  defaultTranslatedText: string | ``;
  intervalId: any | null;
  pickedColor: any | null;
  pickedColorCaptions: any | null;
  pickedBackgroundColor: any | null;
  originalJsonContent: any | null;
  useCaptionBackground: boolean;
  latestTranslationTarget: string | "";
  showTextTab: boolean;
  selectedVoice: string | "";
  selectedVoiceTranslated: string | "";
  showOriginalSummarized: boolean;
  showTranslatedSummarized: boolean;
  origineTokenValue: number;
  translatedTokenValue: number;
  activeAudioDubbing: any,
  summarizesData: any[];
  latestTranslationId: string | "";
  dubbingEnabled: boolean;
  authorLanguage: Language;
  authorLangSelected: boolean;
  storedCaptions: CaptionState[];
  loadedDubbingCached: boolean;
  audioSource: any;
  audioSourceTranslated: any;
  audioContent: string | "";
  audioContentTranslated: string | "";
  parsedCaptionsWithSpeakers: CaptionModel[];
  isMultiLanguageMode: boolean;
  selectedTargetLanguages: Language[];
  bulkTextTranslations: Record<string, string>;
  currentDisplayLanguage: Language;
  /** Help modal: scroll target when result panel is visible */
  pendingHelpScrollSectionId: string | null;
}

export const useYoutubeStore = defineStore("youtubeStore", {
  state: (): YoutubeState => ({
    premiumService: false,
    isLoading: false,
    hasCaption: false,
    hasVideo: false,
    isNotValidLink: false,
    captions: [],
    availableCaptions: [],
    activeCaptionLang: "",
    userInput: "",
    originalVideoSubtitle: "",
    translatedVideoSubtitle: "",
    prebuildVideoSubtitle: ``,
    translatedText: "",
    originalText: "",
    notReadyYet: false,
    isFromNotification: false,
    isTargetListOpen: false,
    isTargetLanguageSelected: false,
    searchQuery: "",
    myLanguagesList: languages,
    isTranslationListOpened: false,
    translationLanguage: {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    },
    originalLanguage: {
      langName: "English",
      langCode: "en",
      countryCode: "us",
    },
    isOpen: false,
    balanceNotEnough: false,
    computePricing: false,
    player: null,
    currentTime: 0,
    currentCaptions: [],
    currentRequestId: "",
    mountPlayer: false,
    videoPlayer: null,
    textTranslationPrice: 0,
    webvttTextArea1: null,
    webvttTextArea2: null,
    defaultOriginalVideoSubtitle: ``,
    defaultTranslatedVideoSubtitle: ``,
    defaultOriginalText: "",
    defaultTranslatedText: "",
    intervalId: null,
    pickedColor: "000000",
    pickedColorCaptions: "000000",
    pickedBackgroundColor: "#000000",
    originalJsonContent: null,
    useCaptionBackground: true,
    latestTranslationTarget: "",
    showTextTab: true,
    selectedVoice: "none",
    selectedVoiceTranslated: "none",
    originalSummarizedText: "",
    translatedSummarizedText: "",
    showOriginalSummarized: false,
    showTranslatedSummarized: false,
    origineTokenValue: 120,
    translatedTokenValue: 120,
    activeAudioDubbing: {},
    summarizesData: [],
    latestTranslationId: "",
    dubbingEnabled: false,
    authorLanguage: {
      langName: "English",
      langCode: "en",
      countryCode: "us",
    },
    authorLangSelected: false,
    storedCaptions: [],
    loadedDubbingCached: false,
    audioSource: null,
    audioSourceTranslated: null,
    audioContent: "",
    audioContentTranslated: "",
    parsedCaptionsWithSpeakers: [],
    isMultiLanguageMode: false,
    selectedTargetLanguages: [],
    bulkTextTranslations: {},
    currentDisplayLanguage: {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    },
    pendingHelpScrollSectionId: null,
}),

  actions: {
    setRequest(requestId: string): void {},
  },
});
